<script setup lang="ts">
import { computed } from 'vue'

interface TProps {
  isMobile?: boolean
  fallbackText?: string
  to?: string
  target?: string
  rel?: string
  overrideCssClass?: string
}

const props = withDefaults(defineProps<TProps>(), {
  isMobile: false,
  fallbackText: 'Link',
  to: '/',
  target: '_self',
  rel: '',
  overrideCssClass: '',
})

const emits = defineEmits<{
  (e: 'clicked'): any
}>()

const { isActive } = useLink(props)

const cssClass = computed((): string => {
  if ((props.overrideCssClass || '').trim().length > 0) {
    return (props.overrideCssClass || '').trim()
  }

  let result =
    'rounded-md py-2 px-3 text-sm font-medium leading-5 bg-none hover:bg-primary hover:content-primary focus:outline-none transition duration-150 ease-in-out'
  if (!!props.isMobile) {
    result = `block text-base ${result}`
  }

  if (isActive.value) {
    result = `bg-primary content-primary ${result}`
  } else {
    result = `content-body ${result}`
  }

  return result
})

const onClick = () => {
  emits('clicked')
}
</script>

<template>
  <ClientOnly fallback-tag="span" :fallback="fallbackText">
    <a :href="to" :rel="rel" :class="cssClass" :target="target" aria-current="page" @click="onClick">
      <slot></slot>
    </a>
  </ClientOnly>
</template>
